// components/ActionButtons.js
import React from 'react';
import { Button } from '@mui/material';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';


const ActionButtons = ({ onDelete, instrumentToken, GUIInstrument, setGUIInstruments, setStockTrackGridlayouts, tabID,
                           onShowDetails }) => (
    <div className="actions-st">
        <Button variant="contained" color="primary">B</Button>
        <Button variant="contained" color="secondary">S</Button>
        <Button variant="contained" color="default" className="small-button"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => onShowDetails(GUIInstrument, setGUIInstruments, setStockTrackGridlayouts, tabID, 11)}  // Add setLayoutKey here
        ><DensitySmallIcon sx={{ fontSize: 16 }}/></Button>
        <Button
            variant="contained"
            color="default"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={() => onDelete(instrumentToken, GUIInstrument, setGUIInstruments, setStockTrackGridlayouts, tabID)}  // Add setLayoutKey here
        >
            <DeleteIcon sx={{ color: '#ff4d4d'}}/>
        </Button>
        <Button variant="contained" color="default" className="small-button"><MoreHorizIcon sx={{ fontSize: 22 }}/></Button>
    </div>
);

export default ActionButtons;
